<template>
  <div class="avecor-table" style="position:fixed; bottom:0px; z-index:100; background:#eee; border:1px solid #ccc; width:100%;max-height:600px">
  
    <div style="position:absolute; left:10px; top:7px;">
      <v-icon 
        class="avecor-table-actions"
        :size="16"
        style="padding-right:10px"
        @click="selectedProductId=null;"
      >
        far fa-window-close
      </v-icon>
    </div>
    <v-row no-gutters justify-center class="pt-1 pb-1" style="">
      <v-col cols="12" class="text-center" style="font-size:20px;">
        {{products[selectedProductId].name.fi}}
      </v-col>
    </v-row>
    <v-tabs
      style="padding-top:0px;"
      fixed-tabs
      dark
      dense
      height="30"
      background-color="#F26539"
      v-model="selectedProductVariationTab"
    >
      <v-tabs-slider color="#FFF"></v-tabs-slider>
      <v-tab href="#details" >Tuotetiedot</v-tab>
      <v-tab href="#productVariations" >Tuotevariaatiot</v-tab>
      <v-tab v-if="allAccess" href="#batches" >Tilatut erät</v-tab>
      <v-tab href="#orderedProducts">Tuotetilaukset</v-tab>
      <v-tab-item value="details" class="product-details-view-tab-item" style="height:387px">
        <v-row no-gutters class="mt-4 pl-5 pr-5" :key="productDataKey">
          <v-col cols="6">
            <v-row no-gutters>
              <v-col cols="5" class="">
                <v-text-field
                  label="Tuotenimi - suomi"
                  placeholder=" "
                  :value="products[selectedProductId].name.fi"
                  @change="inlineSaveProductDetails($event,'fi_name')"
                  filled
                ></v-text-field>
              </v-col>
              <!-- <v-col cols="4" class="pl-3">
                <v-text-field
                  label="Tuotenimi - englanti"
                  placeholder=" "
                  :value="products[selectedProductId].name.en"
                  @change="inlineSaveProductDetails($event,'en_name')"
                  filled
                ></v-text-field>
              </v-col> -->
              <v-col cols="5" class="pl-3">
                <v-text-field
                  label="Tuotenimi - tukkurin"
                  placeholder=" "
                  :value="products[selectedProductId].name.wholesale"
                  @change="inlineSaveProductDetails($event,'wholesale_name')"
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="2" class="pl-3">
                <v-autocomplete
                  autocomplete="off"
                  label="ALV-kanta"
                  :value="products[selectedProductId].vatPercentage"
                  :items="Object.keys(settings.vatPercentages).map(voId => {return settings.vatPercentages[voId]})"
                  @change="inlineSaveProductDetails($event,'vatPercentage')"
                  placeholder=" "
                  persistent-hint
                  item-text="text"
                  item-value="id"
                  filled
                />
              </v-col>
              <v-col cols="2" class="">
                <v-text-field
                  label="Toimitusaika"
                  placeholder=" "
                  :value="products[selectedProductId].deliveryTime"
                  @change="inlineSaveProductDetails($event,'deliveryTime')"
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="2" class="pl-3">
                <v-text-field
                  label="Avecor tuotekoodi"
                  placeholder=" "
                  :value="products[selectedProductId].avecorSku"
                  @change="inlineSaveProductDetails($event,'avecorSku')"
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="2" class="pl-3">
                <v-text-field
                  label="Tukkurin tuotekoodi"
                  placeholder=" "
                  :value="products[selectedProductId].wholesaleSku"
                  @change="inlineSaveProductDetails($event,'wholesaleSku')"
                  filled
                ></v-text-field>
              </v-col>
              
              <v-col cols="2" class="pl-3" v-if="allAccess">
                <v-autocomplete
                  autocomplete="off"
                  label="Tukkuri"
                  :value="products[selectedProductId].wholesaleCompany"
                  :items="getWholesaleCompanies"
                  @change="inlineSaveProductDetails($event,'wholesaleCompany')"
                  persistent-hint
                  item-text="text"
                  item-value="value"
                  filled
                />
              </v-col>
              <v-col cols="2" class="pl-3" v-if="allAccess">
                <v-autocomplete
                  autocomplete="off"
                  label="Merkkaamo"
                  :value="products[selectedProductId].printShops"
                  :items="getPrintShops"
                  @change="inlineSaveProductDetails($event,'printShops')"
                  placeholder=" "
                  persistent-hint
                  item-text="text"
                  item-value="value"
                  filled
                  multiple
                />
              </v-col>
              
              <v-col cols="2" class="pa-0 pl-3">
                <v-autocomplete
                  label="Merkkaustavat"
                  :value="$store.getters.products[selectedProductId].printFormats"
                  :items="settings.printFormats"
                  @change="inlineSaveProductDetails($event,'printFormats')"
                  persistent-hint
                  item-text="fi"
                  item-value="id"
                  multiple
                  filled
                />
              </v-col>
              <v-col cols="6" class="pa-0 pl-0">
                <v-text-field
                  label="Verkkosivulinkki"
                  placeholder=" "
                  :value="products[selectedProductId].websiteLink"
                  @change="inlineSaveProductDetails($event,'websiteLink')"
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="4" class="pa-0 pl-2">
                <v-text-field
                  label="Merkkaus pinta-ala"
                  placeholder=" "
                  :value="products[selectedProductId].printSurfaceArea"
                  @change="inlineSaveProductDetails($event,'printSurfaceArea')"
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="2" class="pl-3">
                <v-text-field
                  label="Tilaus-saldo Kerroin"
                  placeholder=" "
                  :value="products[selectedProductId].orderUnitToStockUnitMultiplier"
                  @change="inlineSaveProductDetails($event,'orderUnitToStockUnitMultiplier')"
                  filled
                  hint="1 tilattu kpl vastaa saldossa x"
                ></v-text-field>
              </v-col>
              <v-col cols="2" class="pl-3">
                <v-checkbox 
                  style="margin-top:0px;"
                  label="Varastotuote?"
                  v-model="products[selectedProductId].warehoused" 
                  @change="inlineSaveProductDetails($event,'warehoused')"
                  class="avecor-table-checkbox">
                </v-checkbox>
              </v-col>
              <v-col cols="2" class="pl-3">
                <v-checkbox 
                  style="margin-top:0px;"
                  label="Merkkaustuote?"
                  v-model="products[selectedProductId].isPrintProduct" 
                  @change="inlineSaveProductDetails($event,'isPrintProduct')"
                  class="avecor-table-checkbox">
                </v-checkbox>
              </v-col>
              <v-col cols="2" class="pl-3">
                <v-checkbox 
                  style="margin-top:0px;"
                  label="2-puoli painatus?"
                  v-model="products[selectedProductId].isDoubleSidePrintPossible" 
                  @change="inlineSaveProductDetails($event,'isDoubleSidePrintPossible')"
                  class="avecor-table-checkbox">
                </v-checkbox>
              </v-col>
              <v-col cols="2" class="pl-3">
                <v-checkbox 
                  style="margin-top:0px;"
                  label="Auto-arkistointi disabloitu?"
                  v-model="products[selectedProductId].autoArchiveDisabled" 
                  @change="inlineSaveProductDetails($event,'autoArchiveDisabled')"
                  class="avecor-table-checkbox">
                </v-checkbox>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  v-if="false"
                  autocomplete="off"
                  label="Merkkauskategoriat"
                  :value="products[selectedProductId].printShopCategories"
                  :items="printShopCategories"
                  @change="inlineSavePrintShopCategoryOptions(selectedProductId,$event,'printShopCategories')"
                  placeholder=" "
                  persistent-hint
                  item-text="text"
                  item-value="id"
                  filled
                  multiple
                />
              </v-col>

            </v-row>
          </v-col>
          <v-col cols="6">
            <v-row no-gutters>
              <v-col cols="12" class="ml-3">
                <v-textarea
                  label="Office kommentit"          
                  @change="inlineSaveProductDetails($event,'officeComments')"
                  :value="products[selectedProductId].officeComments"
                  placeholder=" "
                  filled
                  rows=10
                  :auto-grow="false"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item value="productVariations" class="product-details-view-tab-item">
        <v-row justify-center class="py-2" style="background:#F8F8F8 !important;" no-gutters>
          <v-col cols="12" class="ma-0 py-0 text-right">
            <v-btn-toggle style="margin-right:20px;" v-model="whichProductsToShow" tile>
              <v-btn height="20" class="avecor-button-global" value="active" >
                Aktiviiset
              </v-btn>
              <v-btn height="20" class="avecor-button-global" value="archived">
                Arkistoidut
              </v-btn>
            </v-btn-toggle>
            <v-btn @click.stop="addProductVariation(selectedProductId)" color="#000000" dark class="avecor-button-global add-button mr-3">
              Lisää tuotevariaatio
            </v-btn>
          </v-col>
        </v-row>
        <v-data-table
          v-model="selected"
          :headers="productVariationHeaders"
          :items="getProductVariations"
          :expanded.sync="expanded"
          :single-expand="singleExpand"
          item-key="id"
          hide-default-footer
          hide-default-header
          disable-pagination
          :dense="true"
          class="avecor-ordered-products-table"
          :options="{itemsPerPage:-1}"
          style="border-top:1px solid #ccc;background:#eee"
          fixed-header
          :height="345"
        >
          <template v-slot:header="{ props: { headers } }">
              <thead>
                <tr>
                  <th :key="h.value+'-'+index" v-for="(h, index) in headers" :style="h.value === 'packageType' || h.value === 'select' ? 'font-size:8px;font-weight:300;color:#000;vertical-align:top;':'font-size:8px;font-weight:300;color:#000;'" class="px-1">
                    <div v-if="h.value !== 'batchStatusChange'"><span><b>{{h.text}}</b></span></div>
                    <div v-else><span></span></div>
                    <!-- <div >
                      {{h.value}}
                    </div> -->
                    <!-- @change="batchProductUpdate('packageType')" -->
                    <div v-if="h.value === 'select'" style="max-height:20px;max-width:67px;z-index:1000">
                      <v-checkbox 
                        style="margin-top:0px;"
                        :value="batchStatusAllItems" 
                        @change="v => updateBatchStatusForAllItems(v)"
                        class="avecor-table-checkbox">
                      </v-checkbox>
                    </div>
                    <div v-if="h.value === 'wholesaleSku'" style="max-height:20px;max-width:67px;z-index:1000">
                      
                      <v-text-field
                        v-model="batchProductWholesaleSku"
                        @change="batchProductUpdate('wholesaleSku')"
                        hide-details
                        dense
                        style="background:#ddd; line-height:10px !important"
                        class="avecor-select avecor-header-input pt-0 mt-0 "
                      ></v-text-field>
                    </div>
                    <div v-if="h.value === 'packageType'" style="max-height:35px;width:90px;max-width:90px;z-index:1000">
                      <v-autocomplete
                        autocomplete="off"
                        v-model="batchProductPackageType"
                        :items="getPackageTypes"
                        @change="batchProductUpdate('packageType')"
                        hide-details
                        dense
                        spellcheck="false"
                        item-text="fi"
                        item-value="id"
                        style="background:#ddd"
                        class="avecor-select avecor-header-input pt-0 mt-0 "
                      />
                    </div>
                    
                  </th>
                </tr>
              </thead>
          </template>
          <template v-slot:item="{ item, expand, isExpanded }">
            <tr style="height:25px;" class="hide-field-details">
              <td class="text-xs-center px-1" style="min-width:110px !important;">
                <!-- <v-icon 
                  size=10
                  @click="showOptions(isExpanded, 'products') ? expand(true) : expand(false)"
                >
                  fab fa-product-hunt
                </v-icon> -->
                <!--
                <v-btn @click="expanded.includes(item.id) ? expanded = [] : expanded.push(item.id)">Expand</v-btn>
                <v-icon 
                  size=10
                  @click="showOptions(expanded.includes(item.name), 'products'); expanded.includes(item.name) ? expanded = [] : expanded.push(item.name)"
                >
                  {{item.isExpanded ? "fab fa-product-hunt" : "fab fa-product-hunt"}}
                  {{ expanded  }}
                </v-icon>
                -->
                
                <!-- <v-icon 
                  size=10
                  @click.stop="duplicate(item)"
                  style="padding-left:10px;"
                >
                  far fa-clone
                </v-icon> -->
                <v-icon 
                  :size="10"
                  @click="showOptions(isExpanded, 'images') ? expand(true) : expand(false)"
                  class="ml-2">
                  far fa-images
                </v-icon>
                <v-icon 
                  v-if="item.warehoused"
                  :size="10"
                  @click="toggleWarehouse(item)"
                  color="green"
                  class="ml-2">
                  fas fa-warehouse
                </v-icon>
                <v-icon 
                  v-if="!item.warehoused"
                  :size="10"
                  @click="toggleWarehouse(item)"
                  color="red"
                  class="ml-2">
                  fas fa-warehouse
                </v-icon>
                <v-icon v-if="allAccess && item.archived" color="green" :size="10" @click.stop="toggleArchive(item)" class="ml-2">fas fa-archive</v-icon>
                <v-icon v-if="allAccess && !item.archived"  :size="10" @click.stop="toggleArchive(item)" class="ml-2">fas fa-archive</v-icon>
                <!-- <v-icon 
                  v-if="!item.archived"
                  :size="10"
                  @click="toggleArchive(item)"
                  class="ml-2"
                >fas fa-archive
                </v-icon>
                <v-icon 
                  v-if="item.archived"
                  :size="10"
                  @click="toggleArchive(item)"
                  class="ml-2"
                >fas fa-trash-restore-alt
                </v-icon> -->
                <!-- class="avecor-table-actions" -->
                <v-icon 
                  :size="10"
                  @click="deleteItem(item)"
                  class="ml-2">
                  far fa-trash-alt
                </v-icon>
              </td>
              <td class="text-left">
                <v-checkbox 
                  style="margin-top:0px;"
                  :value="batchStatusUpdateItems[item.id]" 
                  @change="v => updateBatchStatusForItem(item.id)"
                  class="avecor-table-checkbox">
                </v-checkbox>
              </td>
              <td class="">
                <v-text-field
                    slot="activator"
                    class="avecor-date-picker hide-field-details"  
                    :value="item.created_at ? customFormatter(item.created_at) : ''"
                    readonly
                ></v-text-field>
              </td>
              <td style="min-width:125px">
                <v-text-field
                  class="avecor-date-picker hide-field-details"  
                  :value="item.wholesaleSku"
                  @change="inlineSave($event, 'wholesaleSku', item.id)"
                ></v-text-field>
                <!-- <div class="products-custom-field" @click="copyToClipboard(p.deliveryTime)" style="color:rgba(0,0,0,.38);">{{getWholesaleCode() +'-'+ item.wholesaleSku}}</div> -->
              </td>
              <td class="text-xs-left" @click="copyToClipboard(createVariationAvecorSku(item.id))">
                <v-text-field
                  :value="createVariationAvecorSku(item.id)"
                  disabled
                  class="avecor-select hide-field-details"
                ></v-text-field>
              </td>
              <td class="text-xs-left">
                <v-checkbox 
                  style="margin-top:0px;"
                  v-model="item.isAlwaysAvecorStock"
                  @change="inlineSave($event,'isAlwaysAvecorStock',item.id)"
                  class="avecor-table-checkbox">
                </v-checkbox>
              </td>
              <td class="text-xs-left">
                <v-autocomplete
                  autocomplete="off"
                  :value="item.shelfLocation"
                  :items="settings.shelfLocationArray"
                  multiple
                  @change="inlineSave($event, 'shelfLocation', item.id)"
                  persistent-hint
                  class="avecor-select"
                />
              </td> 
              <td class="text-xs-left">
                <v-autocomplete
                  autocomplete="off"
                  :value="item.packageType"
                  :items="getPackageTypes"
                  @change="inlineSave($event, 'packageType', item.id)"
                  persistent-hint
                  item-text="fi"
                  item-value="id"
                  class="avecor-select hide-field-details"
                />
              </td>
              <!-- <td class="text-xs-left" style="max-width:30px">
                <v-text-field
                  :value="item.shape"
                  @change="inlineSave($event, 'shape', item.id)"
                  class="avecor-select"
                ></v-text-field>
              </td> -->
              <td class="text-xs-left minw-100">
                <v-text-field
                  :value="item.color"
                  @change="inlineSave($event, 'color', item.id)"
                  class="avecor-select"
                ></v-text-field>
              </td>
              <td class="text-xs-left minw-100">
                <v-autocomplete
                  autocomplete="off"
                  :value="item.colorCode"
                  :items="getColors"
                  @change="inlineSave($event, 'colorCode', item.id)"
                  persistent-hint
                  item-text="name"
                  item-value="id"
                  class="avecor-select hide-field-details"
                />
              </td>
              <td class="text-xs-left">
                <v-autocomplete
                  autocomplete="off"
                  :value="item.gender"
                  :items="getGenders"
                  @change="inlineSave($event, 'gender', item.id)"
                  persistent-hint
                  item-text="fi"
                  item-value="id"
                  class="avecor-select"
                />
              </td>
              <td class="text-xs-left">
                <v-text-field
                  :value="item.material"
                  @change="inlineSave($event, 'material', item.id)"
                  class="avecor-select"
                ></v-text-field>
              </td>
              <td class="text-xs-left">
                <v-text-field
                  :value="item.size"
                  @change="inlineSave($event, 'size', item.id)"
                  class="avecor-select"
                ></v-text-field>
              </td>
              <td class="text-xs-left">
                <v-text-field
                  :value="item.other"
                  @change="inlineSave($event, 'other', item.id)"
                  class="avecor-select"
                ></v-text-field>
              </td>
              <td class="text-xs-right minw-50">
                <v-text-field
                  :value="item.otherCode"
                  @change="inlineSave($event, 'otherCode', item.id)"
                  class="avecor-select"
                ></v-text-field>
              </td>
              <td class="text-xs-left minw-150">
                <v-textarea
                  rows=1
                  :auto-grow="true"
                  :value="item.additionalInfo"
                  @change="inlineSave($event, 'additionalInfo', item.id)"
                  class="avecor-select"
                ></v-textarea>
              </td>
              <!-- <td class="text-xs-left">
                <v-text-field
                  :value="item.stock"
                  @change="inlineSave($event, 'stock', item.id)"
                  class="avecor-select"
                ></v-text-field>
              </td> -->
              
              <!-- <td class="text-xs-left">
                <v-text-field
                  :value="item.smallOrderExtra"
                  @change="inlineSave($event, 'smallOrderExtra', item.id)"
                  class="avecor-select"
                ></v-text-field>
              </td>
              <td class="text-xs-left">
                <v-text-field
                  :value="item.smallOrderLimit"
                  @change="inlineSave($event, 'smallOrderLimit', item.id)"
                  class="avecor-select"
                ></v-text-field>
              </td>
              <td class="text-xs-left">
                <v-text-field
                  :value="item.minimumOrderQuantity"
                  @change="inlineSave($event, 'minimumOrderQuantity', item.id)"
                  class="avecor-select"
                ></v-text-field>
              </td>
              <td class="text-xs-left">
                <v-text-field
                  :value="item.unitPrintColorPrice"
                  @change="inlineSave($event, 'unitPrintColorPrice', item.id)"
                  class="avecor-select"
                ></v-text-field>
              </td> -->
            </tr>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
            <div class="avecor-table" style="border-top: 1px dotted #ccc ">
              <v-row xs12 no-gutters style="margin-top:10px;" v-if="showImageBar">
                <v-col xs6>
                  <MediaGrid colsPerItem="2" :types="['productImage']" :actions="['delete','copyUrl','download','select']" :product="products[item.productId]" :productVariation="item" ref="mediaGrid"></MediaGrid>
                </v-col>
                <v-col xs6>
                  <MediaUpload type="productImage" :productVariationId="item.id" :productId="selectedProductId" />
                </v-col>
              </v-row>
              <!-- <v-row xs12 no-gutters style="margin-top:10px;" v-if="showPreviousProductsBar">
                <div style="font-size:14px;">Tilaukset joissa tuotetta käytetty</div>
                <v-row pt-3 xs12 row wrap style="margin-top:10px;">
                  <v-col xs2>
                    Tilauksen id
                  </v-col>
                  <v-col xs2>
                    Yritys
                  </v-col>
                  <v-col xs2>
                    Tuotevariaatio
                  </v-col>
                </v-row>
                <v-row xs12 v-for="(key,index) in Object.keys(orderedProductsForSelectedProduct)"  style="margin-top:10px;" v-if="orderedProducts[key].productVariationId === item.id" :key="'ordered-product-'+key">
                  <v-col xs2>
                    <div class="orders-custom-field" style="color:rgba(0,0,0,.38);">{{orderedProducts[key].orderId}}</div>
                  </v-col>
                  <v-col xs2>
                    <div class="orders-custom-field" style="color:rgba(0,0,0,.38);">{{companies[orders[orderedProducts[key].orderId].companyId].companyName}}</div>
                  </v-col>
                  <v-col xs2>
                    <v-autocomplete
                      :value="orderedProducts[key].productVariationId"
                      :items="getCatalogProductsAndVariations"
                      @change="inlineSaveNewProductVariationForOrderedProduct($event,'productVariationId',key)"
                      persistent-hint
                      item-text="text"
                      item-value="value"
                      rows=2
                      class="avecor-select avecor-ordered-producet-select"
                    />
                  </v-col>
                </v-row>
              </v-row> -->
            </div>
            </td>
          </template>
          <template slot="no-data">
          </template>
        </v-data-table>
      </v-tab-item>
      <v-tab-item value="batches" class="product-details-view-tab-item">
        <v-row no-gutters class="pa-4 avecor-ordered-products-table" style="background:#F8F8F8;border-bottom:#ccc 1px solid;">
          <v-col cols="2"/>
          <v-col cols="2" class="ma-0 pa-0 text-right">
            <v-autocomplete
              class="mr-5 maxw-200"
              autocomplete="off"
              label="Suodata tuotevariaatiolla"
              v-model="productVariationIdFilter"
              dense
              :items="getProductVariationsForNewBatch"
              persistent-hint
              item-text="text"
              item-value="value"
              placeholder=" "
            />
          </v-col>
          <v-col cols="6" class="ma-0 pa-0 text-left">
            <v-btn-toggle :multiple="false" :mandatory="true" style="border:1px #ccc solid; " v-model="warehouseFilter">
              <v-btn height="30" class="avecor-button-global avecor-button-group-button" value="all">
                Kaikki
              </v-btn>
              <v-btn height="30" class="avecor-button-global avecor-button-group-button" value="avecorArriving">
                Avecor Saapumassa
              </v-btn>
              <v-btn height="30" class="avecor-button-global avecor-button-group-button" value="printShopArriving">
                Merkkaamo Saapumassa
              </v-btn>
              <v-btn height="30" class="avecor-button-global avecor-button-group-button" value="avecorArrived">
                Avecor Saapuneet
              </v-btn>
              <v-btn height="30" class="avecor-button-global avecor-button-group-button" value="printShopArrived">
                Merkkaamo Saapuneet
              </v-btn>
            </v-btn-toggle>
            <v-btn @click="newBatchModalVisible = true; newBatchModalProductId = selectedProductId" class="add-button avecor-button-global ml-4">Lisää erä</v-btn>
          </v-col>
          <v-col cols="2"/>
        </v-row>
        <!-- :key="batchesKey"  -->
        <v-data-table
          v-model="selectedBatches"
          :headers="batchHeaders"
          :items="getBatches"
          :expanded.sync="expandedBatches"
          :single-expand="singleExpandBatches"
          :sort-by="'estimatedArrivalDate'"
          :sort-desc="false"
          item-key="batchId"
          hide-default-footer
          :key="batchesKey"
          class="avecor-ordered-products-table no-bars"
          :options="{itemsPerPage:-1}"
          style="overflow-y:scroll;background:#eee;"
          fixed-header
          :height="310"
          dense
        >
          <template v-slot:item="{ item, expand, isExpanded }">
            <tr style="max-height:25px;" class="hide-field-details">
              <td class="text-xs-center pa-1 pl-2" style="min-width:50px !important;">
                <v-tooltip top v-if="item.reservations === undefined || item.reservations.orderedProducts === undefined || Object.keys(item.reservations.orderedProducts).length > 0">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      class="px-1"
                      color="primary"
                      size="10"
                      dark
                      v-bind="attrs"
                      v-on="on"
                    >
                      far fa-trash-alt
                    </v-icon>
                  </template>
                  <span>Erää ei voi poistaa. Tilauksia allokoitu tälle erälle.</span>
                </v-tooltip>
                <v-icon 
                  v-else
                  class="avecor-table-actions px-1"
                  size=10
                  
                  @click="deleteBatch(item.pvId, item.batchId)"
                  style="padding-left:10px;"
                >
                  far fa-trash-alt
                </v-icon>
                <v-icon 
                  size=10
                  @click="isExpanded ? expand(false) : expand(true)"
                  style="padding-left:3px;"
                  >
                  far fa-eye
                </v-icon>
              </td>
              <td class="minw-150 non-editable">
                {{createVariationName(productVariations[item.pvId])}}
              </td>
              <td class="text-xs-left maxw-100 minw-50 non-editable">
                <!-- {{item.quantity }} --> <!-- ADD HERE SENT  -->
              </td>
              <td class="text-xs-left maxw-100 minw-50">
                <!-- :disabled="item.stockLocation !== 'notSet'" -->
                <v-text-field
                  :value="item.quantity"
                  @change="(event) => { editBatch(event, 'quantity', item.pvId, item.batchId);}"
                  class="avecor-select hide-field-details non-editable"
                ></v-text-field>
              </td>
              <td class="text-xs-left maxw-100 minw-50 non-editable">
                {{item.quantity - (item.reservations !== undefined && item.reservations.total !== undefined ? item.reservations.total : 0)}}
              </td>
              
              
              <td class="text-xs-left maxw-100">
                <v-text-field
                  :value="item.unitPrice"
                  @change="(event) => { editBatch(event, 'unitPrice', item.pvId, item.batchId);}"
                  class="avecor-select hide-field-details"
                ></v-text-field>
              </td>
              <td class="text-xs-left maxw-100 minw-50 non-editable">
                {{item.quantity * item.unitPrice}}
              </td>
              <td class="text-xs-left maxw-100">
                <v-text-field
                  :value="item.batchShippingPrice"
                  @change="(event) => { editBatch(event, 'batchShippingPrice', item.pvId, item.batchId);}"
                  class="avecor-select hide-field-details"
                ></v-text-field>
              </td>
              <td class="text-xs-left maxw-100">
                <v-text-field
                  :value="item.customs"
                  @change="(event) => { editBatch(event, 'customs', item.pvId, item.batchId);}"
                  class="avecor-select hide-field-details"
                ></v-text-field>
              </td>
              <td class="text-xs-left maxw-100 minw-50 non-editable">
                {{getTotalBatchCost(item)}}
              </td>
              <td class="text-xs-left maxw-100 minw-50 non-editable">
                {{(getTotalBatchCost(item)/item.quantity).toFixed(2)}}
              </td>
              <td class="text-xs-left maxw-100 minw-50 non-editable">
                {{((getTotalBatchCost(item)/item.quantity) ).toFixed(2)}} 
                <!-- // multiplier remove (* 1.15) -->
              </td>
              <td class="text-xs-left maxw-100">
                <v-text-field
                  :value="item.batchTotalWeight"
                  @change="(event) => { editBatch(event, 'batchTotalWeight', item.pvId, item.batchId);}"
                  class="avecor-select hide-field-details"
                ></v-text-field>
              </td>
              
              <td class="text-xs-left">
                <v-menu
                  :nudge-right="80"
                  transition="fade-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="item.expiryDate"
                      readonly
                      class="avecor-select hide-field-details"
                    ></v-text-field>
                  </template>
                  <v-date-picker @change="v => editBatch(v, 'expiryDate', item.pvId, item.batchId)" :value="item.expiryDate" locale="fi-fi"></v-date-picker>
                </v-menu>
              </td>
              <td class="text-xs-left">
                <v-menu
                  :nudge-right="80"
                  transition="fade-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="item.orderDate"
                      readonly
                      class="avecor-select hide-field-details"
                    ></v-text-field>
                  </template>
                  <v-date-picker @change="v => editBatch(v, 'orderDate', item.pvId, item.batchId)" :value="item.orderDate" locale="fi-fi"></v-date-picker>
                </v-menu>
              </td>
              <td class="text-xs-left">
                <v-menu
                  :nudge-right="80"
                  transition="fade-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="item.estimatedArrivalDate"
                      readonly
                      class="avecor-select hide-field-details"
                    ></v-text-field>
                  </template>
                  <v-date-picker @change="v => editBatch(v, 'estimatedArrivalDate', item.pvId, item.batchId)" :value="item.estimatedArrivalDate" locale="fi-fi"></v-date-picker>
                </v-menu>
              </td>
              <td class="text-xs-left minw-150" >
                <v-textarea
                  @change="v => editBatch(v, 'officeComments', item.pvId, item.batchId)"
                  :value="item.officeComments"
                  placeholder=" "
                  rows=1
                  class="avecor-select hide-field-details"
                  hide-details
                  :auto-grow="true"
                ></v-textarea>
              </td>
              <td style="min-width:150px;max-width:300px;" >
                <!-- <v-radio-group
                  class="pt-0 mt-0"
                  :value="item.stockLocation"
                  @change="v => editBatch(v, 'stockLocation', item.pvId, item.batchId)"
                  row
                  :disabled="item.status === 'batchArrivedToWarehouse'"
                  dense
                  hide-details
                  style="min-width:100%; font-size:8px;"
                >
                  <v-radio label="Avecor varasto" value="avecor" />
                  <v-radio label="Merkkaamon varasto" value="printShop"/>
                </v-radio-group> -->
                <div v-if="item.stockLocation === 'avecor'">Avecor</div>
                <div v-if="item.stockLocation === 'printShop'">Merrkaamo</div>

              </td>
              <td class="minw-75 maxw-150 text-center">
                <span v-if="getWholesaleCompanyName !== ''">
                  {{getWholesaleCompanyName}}
                </span>
              </td>
              
        
              <td class="minw-75 maxw-150 text-center">
                <span v-if="getCurrentWholesaleCompanyOrdersContact.email !== ''">
                  {{getCurrentWholesaleCompanyOrdersContact.email}}
                </span>
              </td>
              <td class="minw-75 maxw-75 text-center">
                <v-btn v-if="getCurrentWholesaleCompanyOrdersContact.email !== ''" :href="formGmailLink(getCurrentWholesaleCompanyOrdersContact.email )" text target="_blank">
                  <v-icon size=12>fas fa-external-link-alt</v-icon>
                </v-btn>
              </td>
              <td class="minw-75 maxw-75 text-center">
                <v-autocomplete
                  autocomplete="off"
                  :value="item.numberOfPackages"
                  :items="settings.numberOfPackagesArray"
                  @change="v => editBatch(v, 'numberOfPackages', item.pvId, item.batchId)"
                  persistent-hint
                  class="avecor-select"
                />
              </td>
              <!--  -->
              <td class="minw-75 maxw-75">
                <v-autocomplete
                  autocomplete="off"
                  :disabled="true"
                  :value="item.status"
                  :items="settings.batchStatusArray"
                  @change="v => editBatch(v, 'status', item.pvId, item.batchId)"
                  persistent-hint
                  item-text="text"
                  item-value="id"
                  class="avecor-select"
                />
              </td>
              <td class="text-xs-left">
                <v-menu
                  :nudge-right="80"
                  transition="fade-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="item.arrivalDate"
                      readonly
                      class="avecor-select hide-field-details"
                    ></v-text-field>
                  </template>
                  <v-date-picker @change="v => editBatch(v, 'arrivalDate', item.pvId, item.batchId)" :value="item.arrivalDate" locale="fi-fi"></v-date-picker>
                </v-menu>
              </td>
            </tr>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td v-if="item.reservations && item.reservations.orderedProducts" class="pa-0" :colspan="headers.length" >
              <v-row no-gutters >
                <v-col class="maxw-50" cols="1" />
                <v-col cols="1" style="border-bottom:1px solid #ccc">
                  Tilauspäivä
                </v-col>
                <v-col cols="1" style="border-bottom:1px solid #ccc">
                  Yritys
                </v-col>
                <v-col cols="1" style="border-bottom:1px solid #ccc">
                  Tuote
                </v-col>
                <v-col cols="2" style="border-bottom:1px solid #ccc">
                  Variaatio
                </v-col>
                <v-col cols="1" style="border-bottom:1px solid #ccc">
                  Varattu määrä
                </v-col>
                <v-col cols="1" style="border-bottom:1px solid #ccc">
                  Toimitettu määrä
                </v-col>
                <v-col cols="1" style="border-bottom:1px solid #ccc">
                  Toimitus pvm.
                </v-col>
              </v-row>
              <v-row no-gutters v-for="key in Object.keys(item.reservations.orderedProducts)" :key="key">
                <v-col class="maxw-50" cols="1" />
                <v-col cols="1">
                  {{orders[orderedProducts[key].orderId].created_at ? customFormatter(orders[orderedProducts[key].orderId].created_at) : ''}}
                </v-col>
                <v-col cols="1">
                  {{companies[orders[orderedProducts[key].orderId].companyId].companyName}}
                </v-col>
                <v-col cols="1">
                  {{products[orderedProducts[key].productId].name.fi}}
                </v-col>
                <v-col cols="2">
                  {{createVariationName(productVariations[orderedProducts[key].productVariationId])}}
                </v-col>
                <v-col cols="1">
                  {{item.reservations.orderedProducts[key]}}
                  <!-- {{orderedProducts[key].quantity}} -->
                </v-col>
                <v-col cols="1">
                  {{item.shipped && item.shipped.orderedProducts && item.shipped.orderedProducts[key] ?
                   item.shipped.orderedProducts[key] :
                   ''}}
                  <!-- {{orderedProducts[key].quantity}} -->
                </v-col>
                <v-col cols="1">
                  {{orderedProducts[key].shippedDate}}
                  <!-- {{orderedProducts[key].quantity}} -->
                </v-col>
              </v-row>
                
              <!-- <div class="avecor-table" style="border-bottom: 1px solid #ccc; margin-top:10px; ">
                <v-row no-gutters justify-center >
                  <v-col sm="12">
                    {{item}}
                  </v-col>
                </v-row>
              </div> -->
            </td>
          </template>
          <template slot="no-data">
          </template>
        </v-data-table>
      </v-tab-item>
      <v-tab-item value="orderedProducts" class="avecor-table product-details-view-tab-item">
        <ProductOrderedProductsTable :productId="selectedProductId"/>
      </v-tab-item>
    </v-tabs>
  </div>
</template>


<script>
import { mapFields } from 'vuex-map-fields'
import ProductOrderedProductsTable from './ProductOrderedProductsTable'
//import ProductVariationsTable from './ProductVariationsTable'
import shared from './../../shared'
import dateFormat from 'dateformat'
import firebase from 'firebase'

var db = null

export default {
    components: {
      ProductOrderedProductsTable,
      //ProductVariationsTable
    },
    created(){
      this.createVariationName = shared.createVariationName
      this.createVariationAvecorSku = shared.createVariationAvecorSku
      this.inlineSavePrintShopCategoryOptions = shared.inlineSavePrintShopCategoryOptions
    },
    mounted() {
      db = firebase.firestore();
      this.initiatePricingLayout()
      const table = this.$refs.table
      //db = firebase.firestore();
      if(this.tab !== undefined && this.tab !== ""){
        this.selectedProductVariationTab = this.tab
      }
    },
    props: ['location','tab','productVariationsForSelectedProduct', 'orderedProductsForSelectedProduct'],
    data: () => ({
      pricingLayout:{},
      batchesDynamicKey:456755,
      batchStatusAllItems:false,
      batchProductWholesaleSku:'',
      batchStatusUpdateItems:{},
      batchProductPackageType:'',
      productDataKey:47865456,
      whichProductsToShow: "active",
      numberOfVariations:0,
      productVariationIdFilter:'all',
      warehouseFilter:'avecorArriving',
      batchesKey:6545640,
      selectedProductVariationTab:'details',
      productVariationIdForNewBatch:'',
      stockLocationNewBatch:'',
      quantityForNewBatch:'',
      unitPriceForNewBatch:'',
      batchesForProductVariations:[],
      expiryDateForNewBatch:'',
      estimatedArrivalDateForNewBatch:'',
      statusForNewBatch:'batchOrdered',
      orderDateForNewBatch:new Date().toISOString().split('T')[0],//new Date().getFullYear()+'-'+new Date().getMonth()+'-'+new Date().getDate(),
      newBatchErrors:{
        productVariationId:'',
        quantity:'',
        unitPrice:'',
        expiryDateForNewBatch:'',
        orderDateForNewBatch:'',
        estimatedArrivalDate:'',
        stockLocation:''
      },
      dialog: false,
      showImageBar: false,
      showPreviousProductsBar: false,
      table: null,
      autogrow: true,
      expanded: [],
      singleExpand: true,
      selected: [],
      expandedBatches: [],
      singleExpandBatches: true,
      selectedBatches: [],
      search: '',
      productVariationHeaders: [
        { text: 'Toiminnot', value: 'number', align: 'left', sortable:false},
        { text: '', value: 'select', align: 'left', sortable:false},
        { text: 'Lisätty pvm', value: 'created_at', align: 'left', sortable: false },
        { text: 'Tukkuri-tuotekoodi', value: 'wholesaleSku', align: 'left', sortable: false },
        //{ text: 'Vanha Avecor-tuotekoodi', value: 'sku', align: 'left', sortable: false },
        { text: 'Uusi Avecor-tuotekoodi', value: 'sku', align: 'left', sortable: false },
        { text: 'Aina Avecor Varasto?', value: 'isAlwaysAvecorStock', align: 'left', sortable: false },
        { text: 'Lavapaikka', value: 'shelfLocation', align: 'left', sortable: false },
        { text: 'Paketin tyyppi', value: 'packageType', align: 'left', sortable: false },
        //{ text: 'Muoto', value: 'shape', align: 'left', sortable: false },
        { text: 'Vanha Väri', value: 'color', align: 'left', sortable: false },
        { text: 'Väri valikko', value: 'colorCode', align: 'left', sortable: false },
        { text: 'Sukupuoli', value: 'gender', align: 'left', sortable: false },
        { text: 'Materiaali', value: 'material', align: 'left', sortable: false },
        { text: 'Koko', value: 'size', align: 'left', sortable: false },
        { text: 'Muu variaatio', value: 'other', align: 'left', sortable: false },
        { text: 'Muu variaation tuotekoodi', value: 'otherCode', align: 'left', sortable: false },
        { text: 'Lisätiedot', value: 'additionalInfo', align: 'left', sortable: false },
        //{ text: 'Varasto', value: 'stock', align: 'left', sortable: false },
        /* { text: 'Ilman painatusta', value: 'unitPurchasePrice', align: 'left', sortable: false },
        { text: 'Pientilauslisä', value: 'smallOrderExtra', align: 'left', sortable: false },
        { text: 'Pientilausraja', value: 'smallOrderLimit', align: 'left', sortable: false },
        { text: 'Minimi tilaus', value: 'minimumOrderQuantity', align: 'left', sortable: false },
        { text: 'Hinta/painatusväri', value: 'unitPrintColorPrice', align: 'left', sortable: false }, */
        /* { text: '1-väri free?', value: 'firstPrintColorIncluded', align: 'left', sortable: false },
        { text: '50-99', value: 'unitPrintPrice_50_99', align: 'left', sortable: false },
        { text: '100-249', value: 'unitPrintPrice_100_249', align: 'left', sortable: false },
        { text: '250-499', value: 'unitPrintPrice_250_499', align: 'left', sortable: false },
        { text: '500-999', value: 'unitPrintPrice_500_999', align: 'left', sortable: false },
        { text: '1500-2499', value: 'unitPrintPrice_1500_2499', align: 'left', sortable: false },
        { text: '2500-', value: 'unitPrintPrice_2500_', align: 'left', sortable: false }, */
        /* { text: '250', value: 'unitPrintPrice_250', align: 'left', sortable: false },
        { text: '500', value: 'unitPrintPrice_500', align: 'left', sortable: false },
        { text: '1500', value: 'unitPrintPrice_1500', align: 'left', sortable: false },
        { text: '2000', value: 'unitPrintPrice_2000', align: 'left', sortable: false },
        { text: '1500', value: 'unitPrintPrice_1500', align: 'left', sortable: false },
        { text: '5000', value: 'unitPrintPrice_5000', align: 'left', sortable: false }, */
        /*
        { text: '250', value: 'unitPrintPriceDoubleSided_250', align: 'left', sortable: false },
        { text: '500', value: 'unitPrintPriceDoubleSided_500', align: 'left', sortable: false },
        { text: '1500', value: 'unitPrintPriceDoubleSided_1500', align: 'left', sortable: false },
        { text: '2000', value: 'unitPrintPriceDoubleSided_2000', align: 'left', sortable: false },
        { text: '1500', value: 'unitPrintPriceDoubleSided_1500', align: 'left', sortable: false },
        { text: '5000', value: 'unitPrintPriceDoubleSided_5000', align: 'left', sortable: false },
        */
        
        
      ],
      batchHeaders: [
        { text: 'Toiminnot', value: 'number', align: 'left', sortable:false},
        { text: 'Tuotevariatio', value: 'productVariationName', align: 'left', sortable:true},
        { text: 'Saldo', value: 'quantity', align: 'left', sortable: false },
        { text: 'Tilattu määrä', value: 'quantity', align: 'left', sortable: false },
        { text: 'Myytävissä', value: 'quantity', align: 'left', sortable: false },
        
        { text: 'Ostohinta/kpl', value: 'unitPrice', align: 'left', sortable: false },
        { text: 'Ostohinta yht.', value: 'boughtPrice', align: 'left', sortable: false },
        { text: 'Rahdin hinta', value: 'batchShippingPrice', align: 'left', sortable: false },
        { text: 'Tullaus', value: 'customs', align: 'left', sortable: false },
        { text: 'Yhteensä', value: 'customs', align: 'left', sortable: false },
        { text: 'a-hinta', value: 'fullUnitPrice', align: 'left', sortable: false },
        { text: 'Sisäänostohinta', value: 'fullUnitPriceWithExtra', align: 'left', sortable: false },
        { text: 'Kokonaispaino (kg)', value: 'batchTotalWeight', align: 'left', sortable: false },
        { text: 'Parasta ennen pvm.', value: 'expiryDate', align: 'left', sortable: false },
        { text: 'Tilauspäivä', value: 'orderDate', align: 'left', sortable: true },
        { text: 'Arvioitu saapumispäivä', value: 'estimatedArrivalDate', align: 'left', sortable: true },
        { text: 'Kommentit (office)', value: 'officeComments', align: 'left', sortable: false },
        { text: 'Varasto', value: 'stockAllocation', align: 'left', sortable: false },
        { text: 'Tukkuri', value: 'wholesaleCompany', align: 'left', sortable: false },
        { text: 'Tilaajakontakti', value: 'orderContact', align: 'left', sortable: false },
        { text: 'Tee tilaus', value: 'orderLink', align: 'center', sortable: false },
        { text: 'Pakettien määrä', value: 'numberOfPackages', align: 'left', sortable: false },
        { text: 'Status', value: 'status', align: 'left', sortable: false },
        { text: 'Saapumispäivä', value: 'arrivalDate', align: 'left', sortable: false },
      ],
      
    }),
    computed: {
      printShopCategories(){
        if(this.pricingLayout.printShops){
          var printShopsInPricing = this.pricingLayout.printShops
          var allArray = []
          Object.keys(printShopsInPricing).forEach(psId => {
            var psip = printShopsInPricing[psId]
            var ps = this.printShops[psId]
            var printFormatsPrices = {}
            if(this.printShops[psId] && this.printShops[psId].printFormatsPrices) printFormatsPrices = this.printShops[psId].printFormatsPrices
            var pfArray = []
            Object.keys(printFormatsPrices).forEach(pfId => {
              var pf = printFormatsPrices[pfId]
              var cArray = []
              if(pf.categories){
                Object.keys(pf.categories).forEach(cId => {
                  cArray.push({...pf.categories[cId],id:cId})
                  var c = pf.categories[cId]
                  if(!c.archived){
                    var pfName = this.settings.printFormatsObject[pfId] ? this.settings.printFormatsObject[pfId].fi : ''
                    allArray.push({
                      id:psId+'__'+pfId+'__'+cId,
                      text:ps.name+' | ' +pfName + ' | ' + c.name,
                      psId,
                      psName:ps.name,
                      psFillColor:psip.fillColor,
                      psTextColor:psip.textColor,      
                      pfId,
                      pfName,
                      pfFillColor:pf.fillColor,
                      pfTextColor:pf.textColor,
                      cId,
                      cName:c.name,
                      cOrder:c.order,
                      cExpanded:c.expanded,
                      cFillColor:c.fillColor,
                      cTextColor:c.textColor,
                      options:c.options,
                      ranges:c.ranges,
                      pricingOfficeComments:c.pricingOfficeComments,
                      pricingComments:c.pricingComments,
                      level1Identifier:c.level1Identifier,
                      level2Identifier:c.level2Identifier,
                      extraCosts:c.extraCosts,
                      pricesUpdatedDate:c.pricesUpdatedDate,
                      archived:c.archived ? c.archived : false
                    })
                  }
                })
              }
            })
          })
          allArray.sort((a,b)=>{ 
            var nameA=a.text.toLowerCase().trim(), nameB=b.text.toLowerCase().trim();
            if(this.sortAsc){
              if (nameA > nameB) {return 1;}
              if (nameB > nameA) {return -1;}
              return 0;
            }
            else{
              if (nameA < nameB) {return 1;}
              if (nameB < nameA) {return -1;}
              return 0;
            }
          })
          return allArray
        }
      },
      getColors(){
        var colors = Object.keys(this.settings.colors).map(id => {
          var color = this.settings.colors[id]
          return {...color, name:color.fi + ' ('+color.id+')'}
        })
        return colors.sort((a,b)=>{
          var nameA= a.fi.toLowerCase(), nameB=b.fi.toLowerCase();
          if (nameA > nameB) {
            return 1;
          }
          if (nameB > nameA) {
            return -1;
          }
          return 0;
        })
      },
      allAccess(){
        return this.staff[this.user.uid] !== undefined && (this.staff[this.user.uid].isAdmin || this.staff[this.user.uid].role == 'office' || this.staff[this.user.uid].role == 'warehouse')
      },
      getBatches(){
        var productVariations = this.$store.getters.productVariations
        //this.batchesForProductVariations = []
        var batches = []//this.batchesForProductVariations
        var warehouseFilter = this.warehouseFilter
        var productVariationIdFilter = this.productVariationIdFilter
        var s = Object.keys(this.productVariationsForSelectedProduct).map(function(pvId, index) {
          if(productVariations[pvId].batches !== undefined){
            Object.keys(productVariations[pvId].batches).map(batchId =>{
              
              if(batchId !== "unallocatedAvecor" && batchId !== "unallocatedPrintShop") {
                var batch = productVariations[pvId].batches[batchId]
                if(warehouseFilter === "all") {
                  if(productVariationIdFilter === "all") batches.push({pvId, batchId, ...productVariations[pvId].batches[batchId]})
                  else if(productVariationIdFilter === pvId) batches.push({pvId, batchId, ...productVariations[pvId].batches[batchId]})
                }
                else if(warehouseFilter === "avecorArriving" && batch.stockLocation === 'avecor' && (batch.status === 'batchOrdered' || batch.status === 'batchPartiallyShelfed')) {
                  if(productVariationIdFilter === "all") batches.push({pvId, batchId, ...productVariations[pvId].batches[batchId]})
                  else if(productVariationIdFilter === pvId) batches.push({pvId, batchId, ...productVariations[pvId].batches[batchId]})
                }
                else if(warehouseFilter === "avecorArrived" && batch.stockLocation === 'avecor' && (batch.status === 'batchArrivedToWarehouse' || batch.status === 'batchShelfed')) {
                  if(productVariationIdFilter === "all") batches.push({pvId, batchId, ...productVariations[pvId].batches[batchId]})
                  else if(productVariationIdFilter === pvId) batches.push({pvId, batchId, ...productVariations[pvId].batches[batchId]})
                }
                else if(warehouseFilter === "printShopArriving" && batch.stockLocation === 'printShop' && (batch.status === 'batchOrdered' || batch.status === 'batchPartiallyShelfed')) {
                  if(productVariationIdFilter === "all") batches.push({pvId, batchId, ...productVariations[pvId].batches[batchId]})
                  else if(productVariationIdFilter === pvId) batches.push({pvId, batchId, ...productVariations[pvId].batches[batchId]})
                }
                else if(warehouseFilter === "printShopArrived" && batch.stockLocation === 'printShop' && (batch.status === 'batchArrivedToWarehouse' || batch.status === 'batchShelfed')) {
                  if(productVariationIdFilter === "all") batches.push({pvId, batchId, ...productVariations[pvId].batches[batchId]})
                  else if(productVariationIdFilter === pvId) batches.push({pvId, batchId, ...productVariations[pvId].batches[batchId]})
                }
                
              }
            })
            //return productVariations[key].batches  
          }
        })
        return batches
      },
      
      getCurrentWholesaleCompanyOrdersContact(){
        var contact = {firstName:'',lastName:'',email:'',phone:''}
        if(this.wholesaleCompanies[this.products[this.selectedProductId].wholesaleCompany].partnerContacts){
          Object.keys(this.wholesaleCompanies[this.products[this.selectedProductId].wholesaleCompany].partnerContacts).forEach(key => {
            var c = this.wholesaleCompanies[this.products[this.selectedProductId].wholesaleCompany].partnerContacts[key]
            if(c.contactType === 'ordersContact'){
              contact = c
            }
          })
        }
        return contact
      },
      getWholesaleCompanyName(){
        var wholesaleCompanyName = ""
        if(this.products[this.selectedProductId].wholesaleCompany !== undefined && this.products[this.selectedProductId].wholesaleCompany !== ""){
          if(this.wholesaleCompanies[this.products[this.selectedProductId].wholesaleCompany] && this.wholesaleCompanies[this.products[this.selectedProductId].wholesaleCompany].name){
            wholesaleCompanyName = this.wholesaleCompanies[this.products[this.selectedProductId].wholesaleCompany].name
          }
        }
        return wholesaleCompanyName  
      },
      getWholesaleCompanies(){
        var wholesaleCompanies = this.wholesaleCompanies
        return Object.keys(this.wholesaleCompanies).map(function(key, index) {
          var c = wholesaleCompanies[key]
          return {text: c.name, value: c.id}
          //return {text: c.wholesaleCode+'-'+c.name, value: c.id}
        })
      },
      //this.createVariationName(pv)
      getProductVariationsForNewBatch(){
        var id = this.productId
        var productVariations = this.$store.getters.productVariations
        var t = this
        var variationsArray = []
        variationsArray.push({text:"Kaikki variaatiot", value:'all'})
        variationsArray = Object.keys(this.productVariationsForSelectedProduct).map(function(key, index) {
          var pv = productVariations[key]
          var text = t.createVariationName(pv)
          return {text, value: pv.id}
        })
        return variationsArray
      },
      getPrintShops(){
        var printShops = this.printShops
        return Object.keys(this.printShops).map(function(key, index) {
          var p = printShops[key]
          return {text: p.name, value: p.id}
        })
      },
      getGenders(){
        var genders = this.settings.genders
        return Object.keys(this.settings.genders).reduce(function(result, key) {
          result.push({...genders[key]});
          return result;
        }, []);
      },
      getPackageTypes(){
        var packageTypes = this.settings.packageTypes
        return Object.keys(this.settings.packageTypes).reduce(function(result, key) {
          result.push({...packageTypes[key]});
          return result;
        }, []);
      },
      getCatalogProductsAndVariations(){
        var products = this.$store.getters.products
        var productVariations = this.$store.getters.productVariations
        var catalogProducts = []
        Object.keys(productVariations).forEach(key => {
          var pv = productVariations[key]
          products[pv.productId] ? catalogProducts.push({text: products[pv.productId].name.fi + " - " + this.createVariationName(pv), value: pv.id}) : ''
        })
        return catalogProducts
      },
      getProductVariations(){
        var id = this.selectedProductId
        var productVariations = this.$store.getters.productVariations
        var t = this
        var keys = []
        var pvs = []
        this.numberOfVariations = 0
        Object.keys(productVariations).forEach(key => {
          if (productVariations[key].productId === id) {
            if (this.whichProductsToShow === "archived" && productVariations[key].archived) {
              this.numberOfVariations += 1
              pvs.push(productVariations[key])
            }
            else if (this.whichProductsToShow === "active" && !productVariations[key].archived) {
              this.numberOfVariations += 1
              pvs.push(productVariations[key])
            }
          }
        })
        return pvs
      },
      selectedProductId:{
        get: function () {
          if(this.location === 'products') return this.selectedProductIdInProducts
          else if(this.location === 'stock') return this.selectedProductIdInWarehouse
          else if(this.location === 'prices') return this.selectedProductIdInPrices
          else if(this.location === 'shops') return this.selectedProductIdInShops
        },
        set: function (newValue) {
          if(this.location === 'products') this.selectedProductIdInProducts = newValue
          else if(this.location === 'stock') this.selectedProductIdInWarehouse = newValue
          else if(this.location === 'prices') this.selectedProductIdInPrices = newValue
          else if (this.location === 'shops') this.selectedProductIdInShops = newValue
        }
      },
      ...mapFields({
        mediaManagerOpen:'views.products.mediaManagerOpen',
        settings:"settings",
        productsSearch:"settings.productsSearch",
        productVariations:"productVariation.productVariations",
        orderedProducts:"orderedProduct.orderedProducts",
        orders:"order.orders",
        companies:"company.companies",
        products:"product.products",
        wholesaleCompanies:'wholesaleCompany.wholesaleCompanies',
        printShops:'printShop.printShops',
        selectedProductIdInProducts:"views.products.selectedProduct.productId",
        selectedProductIdInWarehouse:"views.stock.selectedProduct.productId",
        selectedProductIdInPrices:"views.prices.selectedProduct.productId",
        selectedProductIdInShops:"views.shops.selectedProduct.productId",  
        newBatchModalVisible:"modals.batches.new.visible",
        newBatchModalProductId:"modals.batches.new.productId",
        newProductVariation:"newRecords.newProductVariation",
        user:"user",
        staff:"staff.staff"
      }),
    },

    watch: {
      selectedProductId:{
        handler(newId, oldId) {
          if(newId !== oldId) {
            this.batchStatusUpdateItems = {}
            this.batchProductWholesaleSku = ''
            this.batchStatusAllItems = false
            this.batchProductPackageType = ''
          }
        }
      },
    },
    methods: {
      updateBatchStatusForAllItems(value){
        var batchStatusUpdateItems = JSON.parse(JSON.stringify(this.batchStatusUpdateItems))
        this.getProductVariations.forEach(pv =>{
          var id = pv.id
          if(value) batchStatusUpdateItems[id] = true
          else if (batchStatusUpdateItems[id])delete batchStatusUpdateItems[id]
        })
        this.batchStatusAllItems = value
        this.batchStatusUpdateItems = batchStatusUpdateItems
      },
      updateBatchStatusForItem(id){
        var batchStatusUpdateItems = JSON.parse(JSON.stringify(this.batchStatusUpdateItems))
        if(batchStatusUpdateItems[id]) delete batchStatusUpdateItems[id]
        else batchStatusUpdateItems[id] = true
        this.batchStatusUpdateItems = batchStatusUpdateItems
      },
      batchProductUpdate(field){//
        var keys = Object.keys(this.batchStatusUpdateItems)
        if(field == 'packageType'){
          keys.forEach(id=>{
            if(this.batchStatusUpdateItems[id]){
                console.log(this.batchProductPackageType, field, id)
                this.inlineSave(this.batchProductPackageType, field, id)
            }
          })
        }
        else if(field == 'wholesaleSku'){
          keys.forEach(id=>{
            if(this.batchStatusUpdateItems[id]){
                console.log(this.batchProductWholesaleSku, field, id)
                this.inlineSave(this.batchProductWholesaleSku, field, id)
            }
          })
        }
        //GBE/B610
      },
      copyToClipboard (text) {
        this.$clipboard(text)
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:1000, snackText:"Kopioitu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
      },
      /* getAvecorVariationSku(pvId){
        var code = ""
        if(this.products[this.selectedProductId].avecorSku) code += this.products[this.selectedProductId].avecorSku
        if(this.productVariations[pvId].colorCode) code += '-' + this.productVariations[pvId].colorCode  
        return code
      }, */
      toggleWarehouse(item) {
        this.$store.dispatch('productVariation/set', {id:item.id, warehoused:!item.warehoused})
      },
      toggleArchive(item) {
        var archived = item.archived ? true : false
        var m = ''
        if(archived) {m = 'Haluatko varmasti poistaa arkistointi tilan tuotevariaatiolle?'}
        else {m = 'Haluatko varmasti arkistoida tämän tuotevariaation?'}
        if (confirm(m)) {
          this.$store.dispatch('productVariation/set', {id:item.id, archived:!item.archived})
        }
      },
      
      getTotalBatchCost(item){
        var quantity = parseInt(item.quantity)
        var unitPrice = parseFloat(item.unitPrice)
        var batchShippingPrice = parseFloat(item.batchShippingPrice)
        var customs = parseFloat(item.customs)
        var total = 0
        if(!isNaN(quantity) && !isNaN(unitPrice)){
          total += quantity * unitPrice
        }
        if(!isNaN(batchShippingPrice)){
           total += batchShippingPrice
        }
        if (!isNaN(customs)){
          total += customs
        }
        return total
      },
      formGmailLink(email){
        return "https://mail.google.com/mail/?view=cm&fs=1&to="+email+"&su=Uusi tilaus&body=Hei,\nTilaisimme uuden erän"//&bcc=someone.else@example.com"
      },
      showErrorSnack(text){
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:4000, snackText:text, snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
      },
      deleteBatch(pvId, batchId){
        var batches = this.$store.getters.productVariations[pvId].batches
        if (confirm('Haluatko poistaa?')) {
          //delete batches[batchId]
          this.$store.dispatch('productVariation/delete', `${pvId}.batches.${batchId}`)
          .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))

          /* this.$store.dispatch('productVariation/set', {
            id:pvId,
            batches
          })
          .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})) */
        }
      },
      editBatch(value,field,pvId, batchId){
        console.log("HERE1")
        if(pvId === undefined || pvId === "") return
        if(batchId === undefined || batchId === "") return
        if(field === undefined || field === "") return
        //if(value === undefined || value === "") return
        //console.log({value,field,pvId,batchId})
        var batches = this.productVariations[pvId].batches //this.$store.getters.productVariations[pvId].batches
        
        if(field === "quantity"){
          var newBatchQuantity = Number(value)
          if (isNaN(newBatchQuantity)) {
            this.batchesKey++
            alert("Syötä numeerinen määrä.")
          }


          //else if ()
          else {
            //console.log(batches[batchId].reservations.total)
            var reservations = batches[batchId].reservations.total !== undefined ? batches[batchId].reservations.total : 0
            var currentBatchQuantity = batches[batchId].quantity
            if(newBatchQuantity - reservations >= 0 ){
              batches[batchId].quantity = newBatchQuantity
              this.$store.dispatch('productVariation/set', {
                id:pvId,
                batches
              }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
            }
            else {
              this.batchesKey++
              alert("Erästä on varattu suurempi kuin syötetty määrän. Uuden määrän oltava suurempi kun tällä hetkellä varattu.")
            }
          }
        }
        else if(field === "unitPrice"){
          var unitPrice = value !== '' ? parseFloat(value) : ''
          if (isNaN(unitPrice)) {
            this.batchesKey++
            alert("Syötä numeerinen määrä.")
          }
          else {
            batches[batchId].unitPrice = unitPrice
            this.$store.dispatch('productVariation/set', {
              id:pvId,
              batches
            }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
          }
        }
        else if(field === "customs"){
          console.log("CUSTOMS")
          var customs = value !== '' ? parseFloat(value) : ''
          console.log(customs)
          if (isNaN(customs)) {
            this.batchesKey++
            alert("Syötä numeerinen määrä.")
          }
          else {
            batches[batchId].customs = customs
            this.$store.dispatch('productVariation/set', {
              id:pvId,
              batches
            }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
          }
        }
        else if(field === "batchTotalWeight"){
          var batchTotalWeight = value !== '' ? parseFloat(value) : ''
          if (isNaN(batchTotalWeight)) {
            this.batchesKey++
            alert("Syötä numeerinen määrä.")
          }
          else {
            batches[batchId].batchTotalWeight = batchTotalWeight
            this.$store.dispatch('productVariation/set', {
              id:pvId,
              batches
            }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
          }
        }
        else if(field === "batchShippingPrice"){
          var batchShippingPrice = value !== '' ? parseFloat(value) : ''
          if (isNaN(batchShippingPrice)) {
            this.batchesKey++
            alert("Syötä numeerinen määrä.")
          }
          else {
            batches[batchId].batchShippingPrice = batchShippingPrice
            this.$store.dispatch('productVariation/set', {
              id:pvId,
              batches
            }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
          }
        }
        
        else if (field === "status"){
          var pv =  this.$store.getters.productVariations[pvId]
          var currentLocation = this.$store.getters.productVariations[pvId].batches[batchId].stockLocation
          var quantity = this.$store.getters.productVariations[pvId].batches[batchId].quantity
          quantity = Number(quantity)
          batches[batchId].status = value
          
          if(value === "batchArrivedToWarehouse" || value === "batchShelfed"){
            batches[batchId].arrivalDate = new Date().toISOString().substr(0, 10)
            if(currentLocation === 'avecor'){
              this.$store.dispatch('productVariation/set', {
                id:pvId,
                batches
              }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
            }
            else if (currentLocation === 'printShop'){
              this.$store.dispatch('productVariation/set', {
                id:pvId,
                batches
              }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
            }
          }
          else {
            batches[batchId].arrivalDate = ""
            if (currentLocation === 'avecor'){
              this.$store.dispatch('productVariation/set', {
                id:pvId,
                batches
              }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
            }
            else if (currentLocation === 'printShop'){
              this.$store.dispatch('productVariation/set', {
                id:pvId,
                batches
              }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
            }
          }
        }
        else {
          batches[batchId][field] = value
          this.$store.dispatch('productVariation/set', {
            id:pvId,
            batches
          }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
        }
      },
      async addProductVariation(productId) {
        let {...y} = this.newProductVariation;
        var warehoused = this.products[productId].warehoused ? this.products[productId].warehoused : false
        console.log(y)
        const newId = await this.$store.dispatch('productVariation/set', {...y, productId, warehoused})
      },
      showOptions(expanded, button){
        if (button === "products"){
          this.showPreviousProductsBar = !this.showPreviousProductsBar
          if (expanded && this.showImageBar){
            return true
          }
          else if (this.showPreviousProductsBar) {
            return true
          }
          else {
            return false
          }
        }
        else if (button === "images"){
          this.showImageBar = !this.showImageBar
          if (expanded && this.showPreviousProductsBar){
            return true
          }
          else if (this.showImageBar) {
            return true
          }
          else {
            return false
          }
        }
      },
      /* inlineSavePrintShopCategoryOptions(event, field){
        var productId = this.selectedProductId
        console.log(event)
        event.forEach(c => {
          var ids = c.split("__")
          if(this.printShops[ids[0]] && this.printShops[ids[0]].printFormatsPrices[ids[1]] && this.printShops[ids[0]].printFormatsPrices[ids[1]].categories[ids[2]]){
            var ps = this.printShops[ids[0]]
            var printFormatsPrices = JSON.parse(JSON.stringify(ps.printFormatsPrices))
            if(!printFormatsPrices[ids[1]].categories[ids[2]].productsUsing) {
              printFormatsPrices[ids[1]].categories[ids[2]].productsUsing = [productId]
              this.$store.dispatch('printShop/set', {
                id:ids[0],
                printFormatsPrices,
              }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
            }
            else if(!printFormatsPrices[ids[1]].categories[ids[2]].productsUsing.includes(productId)){
              printFormatsPrices[ids[1]].categories[ids[2]].productsUsing.push(productId)
              this.$store.dispatch('printShop/set', {
                id:ids[0],
                printFormatsPrices,
              }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
            }
          }
          console.log(ids)
        })
        this.$store.dispatch('product/set', {
          id:productId,
          [field]:event,
        }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
        
      }, */
      inlineSaveProductDetails(event, field){
        var productId = this.selectedProductId
        if(field === "isDoubleSidePrintPossible" || field === "isPrintProduct")  {
          if(!event) event = false
        }
        if(field === 'orderUnitToStockUnitMultiplier'){
          var multiplier = event.replace(',','.')
          multiplier = Number(multiplier)
          if (isNaN(multiplier)) alert("Syötä numeerinen määrä.")
          else {
            console.log(multiplier)
            this.$store.dispatch('product/set', {
              id:productId, 
              [field]:multiplier
            }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
          }
        }
        //console.log({event,field})
        else if(field === 'avecorSku' || field === 'wholesaleSku'){
          if (confirm('Haluatko varmasti muuttaa tuotekoodia?')) {

            if(event !== undefined && event !== null) {
              this.$store.dispatch('product/set', {
                id:productId, 
                [field]:event
              }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
            }
            else {alert("Virheellinen arvo");this.productDataKey +=1}
          }
          else {
            this.productDataKey +=1
          }
        }
        else if(field === "fi_name"){
          this.$store.dispatch('product/set', {
            id:productId,
            name:{
              fi:event
            },
          }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
        }
        else if(field === "en_name"){
          this.$store.dispatch('product/set', {
            id:productId,
            name:{
              en:event
            },
          }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
        }
        else if(field === "wholesale_name"){
          this.$store.dispatch('product/set', {
            id:productId,
            name:{
              wholesale:event
            },
          }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
        }
        else {
          this.$store.dispatch('product/set', {
            id:productId,
            [field]:event,
          }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
        }
      },
      inlineSaveNewProductVariationForOrderedProduct(productVariationId,field,id){
        var productId = this.$store.getters.productVariations[productVariationId].productId
        //console.log({productVariationId,field,id,productId})
        this.$store.dispatch('orderedProduct/set', {
            id:id,
            productId,
            [field]:productVariationId,
          })
        // USED TO TRIGGER UPDATE TO TABLE => WATCHERS ON PRODUCT VARIATIONS
        this.$store.dispatch('productVariation/set', {
            id:productVariationId
          })
          
      },
      customFormatter(date) {
        if (date.seconds) {
          var myDate = new Date(date.seconds*1000);
          return dateFormat(myDate, "yyyy-mm-dd")
        }
        else if (date !== undefined && date.seconds === undefined){
          return dateFormat(date, "yyyy-mm-dd")
        }
        return ''
      },
      deleteItem (item) {
        var numberOfVariations = Object.keys(this.productVariationsForSelectedProduct).length
        if(numberOfVariations <= 1) alert("Vähintän yksi variaatio oltava.")
        else {
          if (confirm('Haluatko poistaa?')) {
              this.$store.dispatch('productVariation/delete', item.id)
          }
        }
      },
      close () {
        this.dialog = false
        setTimeout(() => {
          this.newItem = Object.assign({}, this.defaultItem)
        }, 300)
      },
      getWholesaleCode(){
        try {
          return this.wholesaleCompanies[this.products[this.selectedProductId].wholesaleCompany].wholesaleCode
        }
        catch (e){
          return ""
        }
      },
      inlineSave(event,field,id) {
        if(field === "otherCode"){
          event = event.toUpperCase()
          event = event.replace(" ","")
          event = event.replace(/Ä/g,"A")
          event = event.replace(/Ö/g,"O")
          
          this.$store.dispatch('productVariation/set', {
            id,
            [field]:event,
          }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
        }
        if(field === "stock"){
          var stock = Number(event)
          if (isNaN(stock)) alert("Syötä numeerinen määrä.")
          else {
            this.$store.dispatch('productVariation/set', {
              id,
              stock,
            }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
          }
          console.log(event) 
        }
        else {
          this.$store.dispatch('productVariation/set', {
            id,
            [field]:event
          }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
        }
      },
      inlineSaveInternalProductData(id, updates) {
        var {stock, ...y} = updates;
        stock = parseInt(stock)
        this.$store.dispatch('internalProductData/set', {
          id,
          stock, 
          ...y
        })
        .then(() => this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
      },
      async duplicate(item){
        var {id, ...y} = item;
        const newId = await this.$store.dispatch('productVariation/set', {
          ...y
        })
        /* var {id, ...y} = this.internalProductData[id];
        this.$store.dispatch('internalProductData/set', {
          id:newId,
          ...y
        }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})) */
        
      },
      initiatePricingLayout(){
        var t= this
        if(this.allAccess){
          db.collection("config").doc("pricingLayout")
            .onSnapshot((doc) => {
              t.pricingLayout = doc.data()
            });
        }
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/blocks/ProductExpand.vue